import { render, staticRenderFns } from "./CustomerComplaintQualityDetail.vue?vue&type=template&id=7938d809&"
import script from "./CustomerComplaintQualityDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintQualityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports